const mainNavButton = document.getElementById('main-nav__button');
const megaMenuButtons = document.querySelectorAll('.mega-menu__button');
const megaMenuBackButton = document.getElementById('mega-menu__back-button');
const megaMenuImageContainer = document.getElementById('mega-menu__image-container');
const megaMenuCloseButton = document.getElementById('mega-menu__mobile-header-close-button');
const mobileHeaderText = document.getElementById('mega-menu__mobile-header-text');
const searchButton = document.getElementById('main-header__search-button');
const search = document.getElementById('main-header__search');
let images = [];

const closeSubMenus = (e) => {
    document.body.classList.remove('mega-menu-open');

    if (megaMenuButtons.length) {
        megaMenuButtons.forEach(function(megaMenuButton) {
            if (megaMenuButton.classList.contains('visible')) {
                toggleVisibility(megaMenuButton, false);
            }
        });
    }

    closeImages();
};

const closeImages = () => {
    if (images.length) {
        images.forEach(function(image) {
            if (image.classList.contains('active')) {
                image.classList.add('closing');
                image.classList.remove('active');
            }
        });

        setTimeout(function() {
            images.forEach(function(image) {
                image.classList.remove('closing');
                image.classList.add('closed');
            });
        }, 400);
    }
};

const toggleMegaMenuBackButton = (e) => {
    closeSubMenus();
    closeImages();
};

const toggleMainNavButton = (e) => {
    if (megaMenuButtons.length) {
        megaMenuButtons.forEach(function(megaMenuButton) {
            loadImage(megaMenuButton, false);
        });
    }

    if (e.currentTarget.classList.contains('active')) {
        closeMenu(e);
    } else {
        document.body.classList.add('nav-menu-open');
        document.addEventListener('keydown', closeMenuOnEsc);

        if (window.innerWidth >= 768 && megaMenuButtons[0]) {
            megaMenuButtons[0].click();
        }
    }

    toggleVisibility(e);
};

const toggleMegaMenuButton = (e) => {
    if (e.currentTarget.classList.contains('active')) {
        if (window.innerWidth < 768) {
            document.body.classList.remove('mega-menu-open');
        } else {
            return;
        }
    } else {
        closeSubMenus();

        if (mobileHeaderText) {
            mobileHeaderText.innerHTML = e.currentTarget.innerHTML;
        }

        document.body.classList.add('mega-menu-open');
    }

    toggleVisibility(e);

    if (e.currentTarget.hasAttribute('data-image') && megaMenuImageContainer) {
        let currentImage = loadImage(e.currentTarget);

        if (images.length) {
            images.forEach(function(image) {
                if (image !== currentImage && image.classList.contains('active')) {
                    image.classList.add('closing');
                    image.classList.remove('active');

                    setTimeout(function() {
                        image.classList.remove('closing');
                        image.classList.add('closed');
                    }, 400);
                }
            });
        }

        currentImage.classList.remove('closing', 'closed');
        currentImage.classList.add('active');
    }
};

const loadImage = (megaMenuButton, setActive = true) => {
    let image = megaMenuButton.getAttribute('data-image');
    let imageID = megaMenuButton.getAttribute('data-image-id');
    let existingImage = document.getElementById(imageID);
    let returnImage;

    if (existingImage) {
        returnImage = existingImage;
    } else if(image) {
        let newImage = document.createElement('div');
        newImage.innerHTML = JSON.parse(image);
        let imageChild = newImage.firstElementChild;

        if (true === setActive) {
            imageChild.classList.add('active');
        }

        megaMenuImageContainer.appendChild(imageChild);
        images.push(imageChild);
        returnImage = imageChild;
    }

    return returnImage;
};

const toggleVisibility = (e, isEvent = true) => {
    let thisElement;

    if (true === isEvent) {
        e.preventDefault();
        thisElement = e.currentTarget;
    } else {
        thisElement = e;
    }

    if (thisElement.classList.contains('visible')) {
        thisElement.classList.remove('active');
        thisElement.classList.remove('open');

        setTimeout(function() {
            thisElement.classList.remove('visible');
        }, 400);
    } else {
        thisElement.classList.add('visible');

        setTimeout(function() {
            thisElement.classList.add('active');
        }, 1);

        setTimeout(function() {
            thisElement.classList.add('open');
        }, 400);
    }
};

const megaMenuResize = () => {
    let menuOffset = window.scrollY;

    if (menuOffset > 40) {
        menuOffset = 40;
    }

    document.documentElement.style.setProperty(
        '--menuOffset',
        `${menuOffset / 16}rem`
    );
};

const closeMenu = (e) => {
    e.preventDefault();
    document.body.classList.remove('nav-menu-open');
    document.body.classList.add('nav-menu-closing');
    mainNavButton.classList.remove('active');
    mainNavButton.classList.remove('open');
    document.removeEventListener('keydown', closeMenuOnEsc);

    setTimeout(function() {
        mainNavButton.classList.remove('visible');
    }, 400);

    setTimeout(function() {
        document.body.classList.remove('nav-menu-closing');
    }, 800);

    closeSubMenus();
};

const closeMenuOnEsc = (e) => {
    if (e.key === 'Escape') {
        closeMenu(e);
    }
};

const megaMenu = () => {
    if (mainNavButton) {
        mainNavButton.addEventListener('click', toggleMainNavButton);
    }

    if (megaMenuButtons.length) {
        loadImage(megaMenuButtons[0], false);

        megaMenuButtons.forEach(function(megaMenuButton) {
            megaMenuButton.addEventListener('click', toggleMegaMenuButton);
        });
    }

    if (megaMenuBackButton) {
        megaMenuBackButton.addEventListener('click', toggleMegaMenuBackButton);
    }

    if (megaMenuCloseButton) {
        megaMenuCloseButton.addEventListener('click', closeMenu);
    }

    if (searchButton && search) {
        searchButton.addEventListener('click', toggleVisibility);
    }
};
export { megaMenu, megaMenuResize };